/*eslint-disable*/export const messages=JSON.parse("{\"icon.title.warning\":[\"Advarselstrekant med et udråbstegn\"]}");